import React from 'react';
import {Button, Card, Col, DatePicker, Form, Icon, Input, message, Modal, Row} from 'antd';
import {fetchEvt, replaceEvtInEvts} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import Iconfont from "../../components/Iconfont/Iconfont";
import {patchCheckinpoints} from "../../services/checkinpoint";
import moment from 'moment';
import lodash from "lodash"
import EvtViewCheckinpointQrcodeForm from "./EvtViewCheckinpointQrcodeForm";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
    replaceEvtInEvts: bindActionCreators(replaceEvtInEvts, dispatch),

});


class EvtViewCheckinpointForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            evtId: props.evt.header.id,
            formLoading: false,
            checkinpointEditable: false,  //二维码
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;

                //去除_开头的属性(为了动态字段添加的)
                var _values = {...values};
                Object.keys(_values).forEach((key) => {
                    if (key != "__self__" && key.startsWith("_")) {
                        delete _values[key]
                    }
                })

                //处理流程的开始结束时间
                if (_values.__self__ && _values.__self__.length > 0) {
                    _values.__self__.forEach((element) => {
                        if (element.beginTime && element.endTime) {
                            element.beginTime = element.beginTime.format("YYYY-MM-DD HH:mm:ss");
                            element.endTime = element.endTime.format("YYYY-MM-DD HH:mm:ss");
                        } else {
                            element.beginTime = null;
                            element.endTime = null;
                        }
                        // delete element.time;
                    })
                }

                patchCheckinpoints(Object.assign({eventId: this.props.evt.header.id}, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, value = {}) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);
        this.setState({
            needReloadUniqueSelect: true,
        })
    }


    removeField = (fieldName, index) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

        this.setState({
            needReloadUniqueSelect: true,
        })
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    // editableChange = (editableStatePropName, editable, dataChanged = false) => {
    //     const statePropObj = {};
    //     statePropObj[editableStatePropName] = editable;
    //     // this.setState(statePropObj, () => {
    //     //     this.props.inEditMode(editable, this.state.tabsActiveKey)
    //     // });
    //     if (!editable && dataChanged) {
    //         this.fetchData();
    //     }
    // }
    // fetchData = (fetchThenFunc = () => this.props.replaceEvtInEvts(this.state.evtId, this.props.evt)) => {
    //     if (this.state.evtId) {
    //         this.props.fetchEvt(this.state.evtId).then(fetchThenFunc ? fetchThenFunc : () => null);
    //     }
    // }
    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;
        getFieldDecorator('___self__', {initialValue: evt.checkinpoints.map(c=>c)});
        const checkinpoints = getFieldValue('___self__') ? getFieldValue('___self__') : [];


        const checkinpointsComp =
            <Row gutter={18} className="form-item-checkinpoint-comp">
                {checkinpoints.map((c, index) => {
                    return (
                        <Col span={12} key={`checkinpoint${index}`}>
                            <Card bodyStyle={{padding: "12px 12px 12px 0"}}>
                                <div className="form-item-checkinpoint-contain">
                                    <div className="form-item-checkinpoint-micon-contain">
                                        <Iconfont libname="ckicon" type="dian"/>
                                    </div>
                                    <div className="form-item-checkinpoint-content-contain">
                                        <div style={{display: "none"}}>
                                            {getFieldDecorator(`__self__[${index}].id`, {
                                                initialValue: c.id,
                                                rules: [{required: false}],
                                            })(
                                                <Input/>
                                            )}
                                        </div>
                                        <div>
                                            {getFieldDecorator(`__self__[${index}].beginTime`, {
                                                initialValue:c.beginTime? moment(c.beginTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                                rules: [
                                                    {required: false, message: ''}
                                                ],
                                            })(
                                                <DatePicker
                                                    showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                    placeholder=""
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    style={{width: "170px"}}
                                                />
                                            )}
                                            ~
                                            {getFieldDecorator(`__self__[${index}].endTime`, {
                                                initialValue:c.endTime? moment(c.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                                rules: [
                                                    {required: false, message: ''}
                                                ],
                                            })(
                                                <DatePicker
                                                    defaultPickerValue={moment('23:59:59', 'HH:mm:ss')}
                                                    disabledDate={endValue=>{
                                                        const startValue = getFieldValue('__self__')[index].beginTime;
                                                        if (!endValue || !startValue) {
                                                            return false;
                                                        }
                                                        return endValue.valueOf() <= startValue.valueOf();
                                                    }}
                                                    showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }}
                                                    placeholder=""
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    style={{width: "170px"}}
                                                />
                                            )}
                                        </div>
                                        <div style={{fontSize:12,color:'#959595'}}>设置签到时间范围，不填是不限制</div>
                                        {/*<Form.Item hasFeedback help="" extra="选填,日期范围限制,超出限制将无法签到.">*/}
                                            {/*{getFieldDecorator(`__self__[${index}].time`, {*/}
                                                {/*initialValue: c.beginTime? [moment(c.beginTime, 'YYYY-MM-DD HH:mm:ss'), moment(c.endTime, 'YYYY-MM-DD HH:mm:ss')]: null,*/}
                                                {/*rules: [{required: false}],*/}
                                            {/*})(*/}
                                                {/*<DatePicker.RangePicker*/}
                                                    {/*showTime={{*/}
                                                        {/*hideDisabledOptions: true,*/}
                                                        {/*defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],*/}
                                                    {/*}}*/}
                                                    {/*allowClear={true}*/}
                                                    {/*format="YYYY-MM-DD HH:mm:ss"*/}
                                                    {/*style={{width: "100%"}}/>*/}
                                            {/*)}*/}
                                        {/*</Form.Item>*/}
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].name`, {
                                                initialValue: c.name,
                                                rules: [{required: true, whitespace: true},{whitespace:true, message: '不能输入空格!'},{min: 1, max: 100, message: '长度限制为1至100个之间!'}],
                                            })(
                                                <Input placeholder="签到点名称，如：创新大会锦江宾馆签到点"/>
                                            )}
                                        </Form.Item>

                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].description`, {
                                                initialValue: c.description,
                                                rules: [{required: false, whitespace: true},{whitespace:true, message: '不能输入空格!'},{min: 1, max: 100, message: '长度限制为1至100个之间!'}],
                                            })(
                                                <Input.TextArea autosize={{minRows: 2, maxRows: 2}} placeholder="签到点备注信息，如：锦江宾馆迎宾主楼签到处，会务部王经理负责，可在本处发放参会证"/>
                                            )}
                                        </Form.Item>

                                    </div>
                                    {index !=0 &&
                                    <a href="#" className="card-ck-contain-remove" onClick={() => this.removeField("__self__", index)}>
                                        <div><Icon type="delete"/>删除</div>
                                    </a>}
                                </div>


                            </Card>
                        </Col>
                    )
                })}
                <Col span={3}>
                    <Card bodyStyle={{padding: "12px"}} style={{border: "none"}}>
                        <a className="card-ck-contain-add" onClick={() => this.addField("__self__")}> <Icon type="plus"/> </a>
                    </Card>
                </Col>
            </Row>

        return (
            <Form>
                <Row gutter={18} className="checkinpoint-comp">
                    {/*{evt.checkinpoints.map((checkinpoint, index) => {*/}
                        {/*return (*/}
                            {/*<Col span={24} key={`checkinpoint${index}`}>*/}
                                {/*<Card*/}
                                    {/*bodyStyle={{padding: "5px"}}>*/}
                                    {/*<div className="checkinpoint-contain">*/}
                                        {/*<div className="checkinpoint-content-contain">*/}
                                            {/*<div>{checkinpoint.name}</div>*/}
                                            {/*<div>*/}
                                                {/*{*/}
                                                    {/*checkinpoint.beginTime ?*/}
                                                        {/*`${checkinpoint.beginTime} ~ ${checkinpoint.endTime}`:"不限制签到日期"*/}
                                                {/*}*/}
                                            {/*</div>*/}
                                            {/*<div>{checkinpoint.description}</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="checkinpoint-micon-contain">*/}
                                            {/*<Iconfont libname="ckicon" type="dian"/>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}
                                {/*</Card>*/}
                            {/*</Col>*/}
                        {/*)*/}
                    {/*})}*/}
                    <EvtViewCheckinpointQrcodeForm
                        evt={this.props.evt}
                        editable={this.state.checkinpointEditable}
                        editableStatePropName={"checkinpointEditable"}
                        editableChange={this.props.editableChange}
                    />
                </Row>

                <Modal
                    visible={this.props.editable}
                    title={<div>点击「+」号可以新增签到点，保存后自动生成签到二维码 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/845029" target='_Blank'>详细帮助</a></div>}
                    width="950px"
                    afterClose={() => this.resetFormFields()}
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    {checkinpointsComp}
                </Modal>
            </Form>
        )
    }
}


EvtViewCheckinpointForm.contextTypes = {}

EvtViewCheckinpointForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "guestEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinpointForm.propTypes = {};


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointForm.jsx